import serviceImage1 from '~/images/services/001.png';
import serviceImage2 from '~/images/services/002.png';
import serviceImage3 from '~/images/services/003.png';
import serviceImage4 from '~/images/services/004.png';
import {services_path} from "@/routes.js";

const services = [
  {
    name: 'Оформление праздников',
    image: serviceImage1,
    url: services_path({ anchor: 'fotozoni'})
  },
  {
    name: 'Ростовые фигуры из картона',
    image: serviceImage2,
    url: services_path({ anchor: 'decor'})
  },
  {
    name: 'Печать баннеров и плакатов',
    image: serviceImage3,
    url: services_path({ anchor: 'banners'})
  },
  {
    name: 'Оформление бизнеса',
    image: serviceImage4,
    url: services_path({ anchor: 'biznes'})
  },
]

export default services;